module.exports = __webpack_public_path__ + "static/media/perfect-gold_00003.372610d8.png";